export default function (app) {
  app.controller('klCustomerCenterCtrl', [
    '$state',
    '$scope',
    'klLocalStorageService',
    'klAccountService',
    'klConfigService',
    function ($state, $scope, LocalStorageService, AccountService, klConfigService) {
      const ctrl = this;
      let isAvailableFromDevToPreProd = false;
      klConfigService.isAvailableFromDevToPreProdEnv().then((result) => {
        isAvailableFromDevToPreProd = result;
      });

      LocalStorageService.setExternal(false);
      ctrl.showAccount = true;
      ctrl.isState = function (query) {
        return $state.includes(query);
      };

      ctrl.isReseller = function () {
        return AccountService.isReseller();
      };

      ctrl.getAccountName = function () {
        return AccountService.getAccount() ? AccountService.getAccount().name : null;
      };

      ctrl.getHeader = function () {
        if ($state.includes('invoice')) {
          return 'Your Invoices';
        }
        if ($state.includes('address')) {
          return 'Your Billing Address';
        }
        if ($state.includes('payment')) {
          return 'Your Payment Method';
        }
        if ($state.includes('subscription') && isAvailableFromDevToPreProd) {
          return '';
        }

        return 'Welcome to your ' + (ctrl.isReseller() ? 'Reseller' : 'Enscape') + ' Account';
      };
    },
  ]);
}
